import { create } from 'zustand';
import { tagService } from '../services/tagService';

const useTagStore = create((set, get) => ({
  tags: [],
  loading: false,
  error: null,

  // Fetch all tags
  fetchTags: async () => {
    set({ loading: true, error: null });
    try {
      const tags = await tagService.getTags();
      set({ tags, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Create a new tag
  createTag: async (tagData) => {
    set({ loading: true, error: null });
    try {
      const newTag = await tagService.createTag(tagData);
      set((state) => ({ 
        tags: [...state.tags, newTag], 
        loading: false 
      }));
      return newTag;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Update an existing tag
  updateTag: async (tagId, tagData) => {
    set({ loading: false, error: null });
    try {
      const updatedTag = await tagService.updateTag(tagId, tagData);
      set((state) => ({
        tags: state.tags.map(tag => tag.id === tagId ? updatedTag : tag),
        loading: false
      }));
      return updatedTag;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Delete a tag
  deleteTag: async (tagId) => {
    set({ loading: true, error: null });
    try {
      await tagService.deleteTag(tagId);
      set((state) => ({
        tags: state.tags.filter(tag => tag.id !== tagId),
        loading: false
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  // Clear error
  clearError: () => set({ error: null }),
}));

export default useTagStore;
